import React from 'react';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';

import Heading from '@marvelapp/marvel-ui/heading';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Button from '@marvelapp/marvel-ui/button';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Image from 'marketing-website/components/modules/Image';

import styles from './style/requestDemo.module.css';

export default function RequestDemo({ backgroundColor = 'blue', image }) {
  return (
    <div className={styles.main}>
      <div className={styles.wrap}>
        {backgroundColor === 'green' && (
          <div className={styles.greenContainer}>
            <div className={styles.left}>
              <Heading tag="h2" weight="bold" size="xxxxl" color="white">
                Switch to Marvel today
              </Heading>
              <MaxWidth value={388}>
                <Paragraph size="xl" color="white">
                  Speak to the team about a personalised demo of Marvel
                  Enterprise for your team.
                </Paragraph>
              </MaxWidth>
              <Spacing size="m" type="margin" position="top">
                <Link to="/enterprise/request-demo">
                  <Button
                    size="extraLarge"
                    color="slate"
                    hover="white"
                    background="white"
                    shape="rounded"
                  >
                    Request a demo
                  </Button>
                </Link>
              </Spacing>
            </div>
            <div className={styles.right}>
              <div className={styles.imageChild}>
                <Image hasShadow={false} {...image} block />
              </div>
            </div>
          </div>
        )}
        {backgroundColor === 'blue' && (
          <div className={styles.blueContainer}>
            <div className={styles.left}>
              <Heading tag="h2" weight="bold" size="xxxxl" color="white">
                Switch to Marvel today
              </Heading>
              <MaxWidth value={388}>
                <Paragraph size="xl" color="white">
                  Speak to the team about a personalised demo of Marvel
                  Enterprise for your team.
                </Paragraph>
              </MaxWidth>
              <Spacing size="m" type="margin" position="top">
                <Link to="/enterprise/request-demo">
                  <Button
                    size="extraLarge"
                    color="slate"
                    hover="white"
                    background="white"
                    shape="rounded"
                  >
                    Request a demo
                  </Button>
                </Link>
              </Spacing>
            </div>
            <div className={styles.right}>
              <div className={styles.imageChild}>
                <Image hasShadow={false} {...image} block />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

RequestDemo.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modules/CompetitorAlternatives/RequestDemo.js